export default __webpack_public_path__ + "static/redLabel-533bbabce32e550177ef68cf5ecdbd65.png";